import { Box, Flex, Text } from "@chakra-ui/react";
import AppLogo from "@/features/ui/app-logo";
import AppButton from "@/features/line-sheet-sets/app-button";
import useWrappedNavigate from "@/features/ui/hooks/use-wrapped-navigate";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";
import { AppUtils } from "@/features/ui/utils/app-utils";
import { Trans } from "react-i18next";

/**
 * 삭제되었거나 발행되지 않은(=바이어가 접근 불가한) 라인시트세트에 바로 접속했을 때 보여주는 페이지.
 * 기존에는 조회가 404/403 으로 실패해 not-found 토스트만 뜨고 화면이 비어 있었는데,
 * 그 대신 이 안내 페이지를 렌더한다.
 * (line-sheet-set-detail-page / line-sheet-set-page / buyer-order-sheet-set-page 에서 사용)
 */
export default function LineSheetNotFoundPage() {
  const navigate = useWrappedNavigate();
  const { tTitle } = useI18nHelper();
  const { calcNavigateTo } = useRouterHelper();

  return (
    <Flex
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      padding="24px"
    >
      <Flex
        maxW="440px"
        w="100%"
        backgroundColor={"#FFF"}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        border="0.5px solid #D4D4D1"
        borderRadius="8px"
        padding={"28px 0px"}
        gap="24px"
        position="relative"
      >
        <AppLogo />
        <Text
          fontSize={"32px"}
          fontWeight={"700"}
          color={"#444444"}
          textAlign={"center"}
        >
          <Trans
            i18nKey={"error_page:line_sheet_not_found_title"}
            components={{
              br: <br />,
            }}
          />
        </Text>
        <Text padding={"0 40px"} fontSize={"14px"} textAlign={"center"}>
          <Trans
            i18nKey={"error_page:line_sheet_not_found_description"}
            components={{
              br: <br />,
            }}
          />
        </Text>
        <Box width={"100%"} padding={"0 80px"}>
          <AppButton
            variant={"gray"}
            width={"100%"}
            size={"large"}
            height={"100%"}
            onClick={() => {
              // '오더하기 > 스탁오더' 목록으로 이동. (없는 라인시트로 다시 튕기지 않도록 navigate(-1) 대신 명시 경로)
              navigate(
                calcNavigateTo(
                  AppUtils.calcPureTo("/line-sheets", {
                    status__in: null,
                    type__eq: "STOCK",
                  })
                )
              );
            }}
          >
            {tTitle("error_page:go_back")}
          </AppButton>
        </Box>

        <Text fontSize={"12px"}>© UNO Trading Corp.</Text>
      </Flex>
    </Flex>
  );
}
